import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import { getTags } from "../../api/commands/tags";

export const Message = defineMessageUnion({
	ClickedRefresh: {},
	CompletedFetchTags: {
		asOf: S.Option(S.String),
		generation: S.Number,
		result: getTags.Result,
	},
});
export type Message = typeof Message.Type;

/** Facts for the root: U7's tag suggestions refresh on `TagsChanged`. */
export const OutMessage = defineMessageUnion({ TagsChanged: {} });
export type OutMessage = typeof OutMessage.Type;
